import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConfigProvider } from "antd";
import { Navigate } from "react-router";

import Home from "./pages/home/home";
import CreateUser from "./pages/create-user/create-user";
import UserManagement from "./pages/user-management/user-management";
import LoginQRCode from "./pages/login-qr-code/login-qr-code";
import QRVerified from "./pages/qr-verified/qr-verified";
import LoginQREmail from "./pages/login/login-qr-email";
import WebServerA from "./pages/web-server-a";
import WebServerB from "./pages/web-server-b";
import AuthenticationScreen from "./pages/authentication";
import LoginIPAddr from "./pages/ip-verified/login-ip-addr";
import IPAuthenticationScreen from "./pages/ip-verified/authentication-ip";
import LoginOTP from "./pages/login-otp/login-otp-phone";
import LoginOTPVerified from "./pages/login-otp/login-otp-verify";
import Login from "./pages/login";
import LoginAdmin from "./pages/login/login-admin";
import RegisterIPAddr from "./pages/ip-verified/register-ip-addr";
import RedirectSSO from "./pages/redirect-sso";

function App(): JSX.Element {
  return (
    <div className="App">
      <ConfigProvider
        direction="ltr"
        theme={{ token: { colorPrimary: "#40C1A2" } }}
      >
        <BrowserRouter>
          <Routes>
            <Route element={<div>
              <h3>The App is Healthy</h3>
            </div>} path="/healthz">
            </Route>
            <Route element={<Login />} path="/" />
            <Route element={<RedirectSSO />} path="/redirect" />
            <Route element={<AuthenticationScreen />} path="/authen" />
            <Route element={<WebServerA />} path="/web-server-a" />
            <Route element={<WebServerB />} path="/web-server-b" />
            <Route element={<LoginAdmin />} path="/admin/login" />
            <Route element={<LoginOTP />} path="/admin/login-otp" />
            <Route element={<LoginOTPVerified />} path="/admin/otp-verified" />
            <Route element={<RegisterIPAddr />} path="/register-ip-addr" />
            <Route element={<IPAuthenticationScreen />} path="/ip-verified" />
            <Route element={<LoginIPAddr />} path="/login-ip-addr" />

            <Route element={<LoginAdmin />} path="/admin/login" />
            <Route element={<LoginQRCode />} path="/login-qr-code" />
            <Route element={<QRVerified />} path="/qr-verified" />
            <Route element={<LoginQREmail />} path="/qr-email" />

            <Route
              element={<Home />}
              path="/admin"
              children={[
                <Route element={<Navigate to="user-management" />} path="" />,
                <Route element={<UserManagement />} path="user-management" />,
                <Route element={<CreateUser />} path="create-user" />,
              ]}
            />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </div>
  );
}

export default App;
